import { gluer } from 'femo';
const initPermissions = null;
const permission = gluer(initPermissions);
export default {
    permission,
};
